module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp13_8017.1da31564.png";